import _ from 'lodash';
import React from 'react';

import Loader from 'components/Loader';
import {default as Modal, withModal} from 'components/Modal';

import {BaseInformation, DraftInvoiceItemsTable, Totals} from './components';

import {
  SCHEDULE_TYPES,
  fetchDraftInvoice,
  deleteDraftInvoice,
  approveDraftInvoice
} from 'ducks/tenancy';
import {composeActions} from 'ducks/common';
import {
  MODALS as BASE_MODALS,
  openModal,
  closeModal,
  storeDataInModal
} from 'ducks/modals';
import {MODALS} from 'ducks/bookings';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import './styles.css';

class DraftInvoiceDetailModal extends React.Component<any> {
  componentDidMount() {
    const {data: {draftInvoiceId, locationRef}} = this.props;

    this.props.requiresPermission(
      {permission: PERMISSIONS.VIEW_SCHEDULE_ITEM_DETAILS, locationRef},
      () => {
        const fetchDraftInvoiceExtraAction = this.props.storeDataExtraActions(
          data => ({
            draftInvoice: data
          })
        );
        this.props.fetchDraftInvoice(
          {draftInvoiceId},
          fetchDraftInvoiceExtraAction
        );
      }
    );
  }

  openConfirmationModal = ({heading, confirmAction, question, warnings}) =>
    this.props.openModal(BASE_MODALS.CONFIRM, {
      heading,
      question,
      confirmAction,
      warnings
    });

  getSuccessExtraActions = () => {
    return [
      ...this.props.closeModalExtraActions,
      ...this.props.refetchExtraActions({
        tenancyId: this.props.data.tenancyId,
        scheduleType: this.props.data.scheduleType
      })
    ];
  };

  delayedFetchScheduleAction = () =>
    this.props.delayExtraActions({
      tenancyId: this.props.data.tenancyId,
      scheduleType: this.props.data.scheduleType
    });

  deleteDraftInvoiceConfirmAction = () => {
    const {draftInvoiceId} = this.props.data;

    const successExtraActions = [
      () => closeModal(BASE_MODALS.CONFIRM),
      ...this.getSuccessExtraActions(),
      ...this.delayedFetchScheduleAction()
    ];
    const failureExtraActions = [
      ({errors}) =>
        storeDataInModal({
          modalName: BASE_MODALS.CONFIRM,
          data: {errors, submitting: false}
        })
    ];

    this.props.storeDataInModal({
      modalName: BASE_MODALS.CONFIRM,
      data: {submitting: true}
    });

    this.props.deleteDraftInvoice(
      {draftInvoiceId},
      successExtraActions,
      failureExtraActions
    );
  };

  approveDraftInvoiceConfirmAction = () => {
    const {draftInvoiceId} = this.props.data;

    const successExtraActions = [
      () => closeModal(BASE_MODALS.CONFIRM),
      ...this.getSuccessExtraActions(),
      ...this.delayedFetchScheduleAction()
    ];
    const failureExtraActions = [
      ({errors}) =>
        storeDataInModal({
          modalName: BASE_MODALS.CONFIRM,
          data: {errors, submitting: false}
        })
    ];

    this.props.storeDataInModal({
      modalName: BASE_MODALS.CONFIRM,
      data: {submitting: true}
    });

    this.props.approveDraftInvoice(
      {draftInvoiceId},
      successExtraActions,
      failureExtraActions
    );
  };

  deleteDraftInvoice = () => {
    const {data: {locationRef}} = this.props;

    this.props.requiresPermission(
      {permission: PERMISSIONS.DELETE_DRAFT_INVOICE, locationRef},
      () => {
        this.openConfirmationModal({
          heading: 'Delete Draft Invoice',
          question: 'Are you sure you want to delete this draft invoice?',
          confirmAction: this.deleteDraftInvoiceConfirmAction,
          warnings: []
        });
      }
    );
  };

  approveDraftInvoice = () => {
    const {data: {locationRef}} = this.props;

    this.props.requiresPermission(
      {permission: PERMISSIONS.APPROVE_DRAFT_INVOICE, locationRef},
      () => {
        this.openConfirmationModal({
          heading: 'Approve Draft Invoice',
          question: 'Are you sure you want to approve this draft invoice?',
          confirmAction: this.approveDraftInvoiceConfirmAction,
          warnings: []
        });
      }
    );
  };

  render() {
    const scheduleType = _.get(this.props, 'data.scheduleType');
    const loading = _.get(this.props, 'data.loading');
    const draftInvoice = _.get(this.props, 'data.draftInvoice');

    let modalType = Modal.MEDIUM;
    if (draftInvoice && scheduleType === SCHEDULE_TYPES.RENT) {
      modalType = Modal.LARGE;
    }

    return (
      <div>
        {draftInvoice && (
          <Modal
            show={true}
            onClose={this.props.closeModal}
            type={modalType}
            className="DraftInvoiceDetailModal">
            <Modal.Header>
              <h2 className="header">Draft Invoice </h2>
            </Modal.Header>
            <Modal.Body>
              <BaseInformation
                draftInvoice={draftInvoice}
                scheduleType={scheduleType}
                approveDraftInvoice={this.approveDraftInvoice}
                deleteDraftInvoice={this.deleteDraftInvoice}
              />
              <DraftInvoiceItemsTable draftInvoice={draftInvoice} />
              <Totals draftInvoice={draftInvoice} />
              {loading && (
                <div className="loaderContainer .colab-centered">
                  <Loader />
                </div>
              )}
            </Modal.Body>
          </Modal>
        )}
        {!draftInvoice && null}
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchDraftInvoice,
  requiresPermission,
  openModal,
  composeActions,
  deleteDraftInvoice,
  approveDraftInvoice,
  storeDataInModal
};

export default withModal(
  MODALS.DRAFT_INVOICE_DETAIL,
  undefined,
  mapDispatchToProps
)(DraftInvoiceDetailModal);
